import { useContext } from 'react';
import { SiteContext } from 'src/context/site-context';
import { isMeridianRedesignEnabled } from 'src/enums/build/meridian-redesign-state';

export const useIsRedesignEnabledForDomain = () => {
  const { isDL, isMeridian } = useContext(SiteContext);

  return isDL || (isMeridian && isMeridianRedesignEnabled());
};
